import script from "./MakerCartCartPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartCartPage.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartCartPage.vue?vue&type=style&index=0&id=2e87f738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e87f738"]])

export default __exports__